import { PageHeader } from "@/pages/Categories";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHeader eyebrow="LEGAL" title="Terms of Use" sub={`Last updated ${new Date().getFullYear()}.`} />
      <section className="max-w-3xl mx-auto px-6 lg:px-8 pb-24 text-[14.5px] text-zinc-300 leading-relaxed space-y-6">
        <Block t="Acceptance">
          By accessing vyrtrade.com or submitting a sourcing enquiry, you agree to these Terms of Use.
        </Block>
        <Block t="Nature of our services">
          VYR Trade is a sourcing and trade-facilitation company. Unless explicitly stated in writing, we do not manufacture goods. Supplier verification, certifications, samples and compliance documents are coordinated case by case with Indian manufacturers.
        </Block>
        <Block t="No fake claims">
          We do not represent that all our suppliers carry generic certifications (e.g. &ldquo;ISO certified&rdquo;) in the abstract. Specific certifications, audit reports and compliance documents are validated and shared on a per-supplier, per-engagement basis.
        </Block>
        <Block t="Compliance">
          Compliance with import regulations, product safety, labelling, REACH, CE marking, and any other regulatory requirements in the destination country is the responsibility of the buyer. We support documentation coordination but do not provide regulatory or legal advice.
        </Block>
        <Block t="Engagement & fees">
          Specific scope of work, fees, payment terms and deliverables for each engagement are set out in a separate written agreement. Nothing on the Site constitutes a binding offer.
        </Block>
        <Block t="Intellectual property">
          All content on the Site (text, layout, brand marks, images) is owned by or licensed to VYR Trade. You may not reproduce or republish material without prior written consent.
        </Block>
        <Block t="Limitation of liability">
          To the maximum extent permitted by law, VYR Trade shall not be liable for indirect or consequential damages arising from the Site, sourcing recommendations, or any supplier introductions.
        </Block>
        <Block t="Governing law">
          These Terms are governed by the laws of England and Wales. Disputes will be subject to the exclusive jurisdiction of the courts of England and Wales, except where mandatory consumer law of your country of residence provides otherwise.
        </Block>
        <Block t="Contact">
          For any questions, please email <a className="text-amber-400" href="mailto:reachus@vyrtrade.com">reachus@vyrtrade.com</a>.
        </Block>
      </section>
    </div>
  );
}

function Block({ t, children }) {
  return (
    <div>
      <div className="font-display text-xl font-semibold text-white">{t}</div>
      <p className="mt-2 text-zinc-300">{children}</p>
    </div>
  );
}
